import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import ProcessSection from "@/components/sections/ProcessSection";
import { IMG } from "@/data/content";

export default function Process() {
  return (
    <>
      <Seo title="Our Process | HM Services" description="A clear six-step process — from property evaluation to ongoing growth support — that helps your hospitality business build a stronger online presence." path="/process" image={IMG.marketing} />
      <PageHero eyebrow="How We Work" title="From First Conversation to Ongoing Growth" subtitle="A transparent, practical process designed around your property, your guests and your goals." image={IMG.marketing} />
      <ProcessSection />
      <CTASection />
    </>
  );
}
